module.exports = __webpack_public_path__ + "static/media/moldura-rg-verso.82c2e1c9.svg";